import { Component, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../../_services/organisation/organisation-preferences.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-onboarding-branding',
  templateUrl: './onboarding-branding.component.html',
  styleUrls: ['../styles.scss', './onboarding-branding.component.scss']
})
export class OnboardingBrandingComponent implements OnInit {

  isLoading = false;
  active = false;

  brandingForm: FormGroup = new FormGroup({
    brandingBannerColour: new FormControl(),
    brandingTextColour: new FormControl(),
  });

  constructor(
      private readonly organisationPreferencesService: OrganisationPreferencesService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.organisationPreferencesService.getPreferences().subscribe(data => {
      if (data) {
        this.active = data.branding_banner;
        this.brandingForm.get('brandingBannerColour')?.setValue(data.branding_banner_colour);
        this.brandingForm.get('brandingTextColour')?.setValue(data.branding_text_colour);
        this.isLoading = false;
      }
    });
  }

  submit(value: boolean) {
    this.organisationPreferencesService.updatePreference('branding_banner', value).subscribe(res => {
      this.getPreferences();
    });
  }

  setColours() {
    if (this.active) {
      this.isLoading = true;
      const backgroundColour = this.brandingForm.get('brandingBannerColour')?.value;
      this.organisationPreferencesService.updatePreference('branding_banner_colour', backgroundColour).subscribe(res => {
        const textColour = this.brandingForm.get('brandingTextColour')?.value;
        this.organisationPreferencesService.updatePreference('branding_text_colour', textColour).subscribe(res2 => {
          this.getPreferences();
        });
      });
    }
  }
}
